import { PageHeader } from '@/components/PageHeader';
import { areaDe } from '@/app/areas';
import { AvisoDeFase } from '@/features/gym/GymPage';

interface Props {
  ruta: string;
}

/**
 * Marcador de posición de las áreas de Más que llegan en fases posteriores
 * (Plan, Mantenimiento, Excel): "Llega en la Fase N" con lo que trae, en lugar
 * de una pantalla en blanco (tarea 4.1), con el estilo de Foco.
 */
export function PlaceholderPage({ ruta }: Props) {
  const area = areaDe(ruta);
  if (area === undefined) return null;

  return (
    <div>
      <PageHeader
        titulo={area.titulo}
        descripcion={area.descripcion}
        volver={{ a: '/mas', texto: 'Volver', etiqueta: 'Volver a Más' }}
      />
      <AvisoDeFase ruta={ruta} />
    </div>
  );
}
